/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { IbisPreparedStatement } from './ibis-prepared-statements';

export class IbisData {
  ID: string;

  GROWTH_RATE_PRIOR: number;
  GROWTH_RATE_NEXT: number;

  FUTURE_PROSPECTS: string;
  INDUSTRY_DEFINITION: string;
  EXECUTIVE_SUMMARY: string;
  INDUSTRY_PERFORMANCE: string;
  INDUSTRY_OUTLOOK: string;
  INDUSTRY_OUTLOOK_IMG: string;
  PRODUCT_SERVICES: string;
  INDUSTRY_COST: string;

  PROFIT: number;
  WAGES: number;
  PURCHASES: number;
  MARKETING: number;
  DEPRECIATION: number;
  RENT: number;
  UTILITIES: number;
  OTHER_COSTS: number;

  EXTERNAL_DRIVERS: IbisPreparedStatement[];

  constructor(values: any = {}) {
    Object.assign(this, values);
  }
}
